import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-75ab29dc"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "login-panel"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "captcha-wrapper"
};
const _hoisted_4 = {
  class: "img-wrap"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "new-btn-wrap"
};
const _hoisted_7 = {
  class: "top"
};
const _hoisted_8 = {
  class: "center"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "split-line"
}, null, -1));

import DecorateLine from '@/components/decorate-line';
import { rules } from '../config/account-config';
import { reactive, ref, watch } from 'vue';
import useUserStroe from '@/store/modules/user.js';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
export default {
  __name: 'login-panel',

  setup(__props) {
    const {
      t
    } = useI18n();
    const formRef = ref();
    const account = reactive({
      username: '',
      password: '',
      captcha_text: ''
    });
    const userStore = useUserStroe();
    const router = useRouter(); // 登录处理

    const handleLogin = () => {
      const formData = {
        account: account.username,
        password: account.password,
        captcha_text: account.captcha_text,
        captcha_img: userStore.image_id
      };
      userStore.accountLogin(formData);
    };

    const handleLoginClick = () => {
      var _formRef$value;

      (_formRef$value = formRef.value) === null || _formRef$value === void 0 ? void 0 : _formRef$value.validate(valid => {
        if (valid) {
          handleLogin();
        }
      });
    };

    const handleRegistClick = () => {
      router.push('/register');
    }; // 输入密码时才显示验证码


    const isLoadCaptcha = ref(false);
    watch(() => account.password, newVal => {
      if (newVal) {
        isLoadCaptcha.value = true;
      }
    });
    watch(isLoadCaptcha, newVal => {
      if (newVal) {
        userStore.fetchCaptchaImage();
      }
    }); // 刷新验证码

    const handleRefreshVerifyImgClick = () => {
      userStore.fetchCaptchaImage();
    };

    const hangleResetpwdClick = () => {
      router.push('/reset-password');
    };

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_link = _resolveComponent("el-link");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(DecorateLine), {
        multiple: 2
      }), _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('login.title')), 1), _createVNode(_component_el_form, {
        model: account,
        ref_key: "formRef",
        ref: formRef,
        rules: _unref(rules),
        "hide-required-asterisk": "",
        "label-position": "left"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          prop: "username"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: account.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => account.username = $event),
            onKeydown: _withKeys(handleLoginClick, ["enter"]),
            placeholder: _ctx.$t('login.account'),
            size: "large"
          }, null, 8, ["modelValue", "onKeydown", "placeholder"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          prop: "password"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: account.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => account.password = $event),
            "show-password": "",
            onKeydown: _withKeys(handleLoginClick, ["enter"]),
            placeholder: _ctx.$t('login.password'),
            size: "large"
          }, null, 8, ["modelValue", "onKeydown", "placeholder"])]),
          _: 1
        }), isLoadCaptcha.value ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          prop: "captcha_text"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            class: "verifi-box"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: account.captcha_text,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => account.captcha_text = $event),
                onKeydown: _withKeys(handleLoginClick, ["enter"]),
                placeholder: _ctx.$t('login.verifyCode'),
                size: "large"
              }, null, 8, ["modelValue", "onKeydown", "placeholder"])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
                src: _unref(userStore).image_url,
                alt: "",
                onClick: handleRefreshVerifyImgClick
              }, null, 8, _hoisted_5), _createVNode(_component_el_link, {
                onClick: handleRefreshVerifyImgClick,
                type: "primary"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('login.refreshVerifyCode')), 1)]),
                _: 1
              })])])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["model", "rules"]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
        type: "primary",
        class: "login-btn",
        onClick: handleLoginClick
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('login.loginBtn')), 1)]),
        _: 1
      })]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_link, {
        onClick: handleRegistClick,
        type: "primary"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('login.registerBtn')), 1)]),
        _: 1
      }), _hoisted_9, _createVNode(_component_el_link, {
        onClick: hangleResetpwdClick,
        type: "primary"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('login.forgetPwdBtn')), 1)]),
        _: 1
      })])])]);
    };
  }

};